import React from 'react';
import PropTypes from 'prop-types';

import IconLoading from '../icon/loading';
import Label from '../label';

import './loading.styl'
class Loading extends React.Component {
    static propTypes = {
        className: PropTypes.string,
        printable: PropTypes.bool,
        type: PropTypes.oneOf(['spin','bars', 'bubbles', 'cylon', 'spin', 'spinningBubbles'])
    }
    static defaultProps = {
        printable: false,
        type: "spin"
    }

    render() {
        if(!this.props.printable) return ''
        const {className, type} = this.props;

        return <div className={'loading' + (className ? ' ' + className : '')}>
            <IconLoading type={type} />
            <h2><Label>app.loading</Label>...</h2>
        </div>
    }
}

export default Loading;
